import { render, staticRenderFns } from "./RealtimeRouting.vue?vue&type=template&id=b57013f4&"
import script from "./RealtimeRouting.vue?vue&type=script&lang=js&"
export * from "./RealtimeRouting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports